import { useCallback, useRef } from 'react';
/**
 * Returns an internal object ref and a stable callback ref that assigns the same element
 * to the internal ref and every provided ref.
 * Supports callback refs, mutable object refs, and nullish refs.
 */
export function useMergeRef(...refs) {
    const internalRef = useRef(null);
    const refCallback = useCallback((element) => {
        internalRef.current = element;
        refs.forEach((ref) => {
            if (!ref)
                return;
            if (ref instanceof Function) {
                ref(element);
                return;
            }
            ref.current = element;
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
    return [internalRef, refCallback];
}
//# sourceMappingURL=useMergeRef.js.map